import { Route, Switch } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { FaRegNewspaper } from 'react-icons/fa';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { GiCardboardBoxClosed } from 'react-icons/gi';
import { useHistory } from 'react-router';
import { useSpotlightActions } from '../../AppSpotlight';

MenuManager.RegisterItem({
	parent: 'content',
	key: 'News',
	path: '/news',
	name: 'Новости',
	icon: <FaRegNewspaper />,
	acl: 'blog',
	position: 10
});

function NewsRoute (props) {
	const history = useHistory();
	const basePath = props.path || '/news';
	const getPath = (path = '') => `${basePath}${path}`;

	useSpotlightActions([{
		id: 'news.page',
		title: 'Новости',
		icon: <FaRegNewspaper />,
		onTrigger: () => history.push(getPath())
	}, {
		id: 'news.categories',
		title: 'Категории новостей',
		icon: <FaRegNewspaper />,
		onTrigger: () => history.push(getPath('/categories'))
	}]);

	const List = useLoadComponent(() => import('./List').then((e) => e.NewsListPage), {
		basePath
	});

	const Edit = useLoadComponent(() => import('./Edit').then((m) => m.EditBlog), {
		basePath
	});

	const Categories = useLoadComponent(() => import('./Categories/CategoriesRoute').then((e) => e.CategoriesRoute), {
		basePath,
		path: getPath('/categories')
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					path={getPath('/categories')}
					component={Categories}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={Edit}
				/>
			</Switch>
		</>
	);
}

NewsRoute.propTypes = {
	path: PropTypes.string
};

export { NewsRoute };
